import React from 'react';
import {
    Accordion,
    AccordionBody,
    AccordionHeader,
    Button,
    AccordionItem, Card, CardHeader, CardGroup, CardBody, ListGroup, ListGroupItem, Row, Col, Table, ListGroupItemText
} from 'reactstrap';
import { useNavigate, useLocation, } from "react-router-dom";
const CertificateInformation1 = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const coursetrack = location.state ? location.state.courseTrack : "";
    const coursename = location.state ? location.state.courseName : "";
    const [open, setOpen] = React.useState(['7']); // Initialize open state with an empty array

    const toggle = (id) => {
        setOpen(prevOpen => {
            if (prevOpen.includes(id)) {
                // If the section is already open, remove it from the open state
                return prevOpen.filter(item => item !== id);
            } else {
                // If the section is not open, add it to the open state
                return [...prevOpen, id];
            }
        });
    };
    const handleEnrollClick = () => {

        navigate("/application-form", {
            state: {
                courseTrack: coursetrack,
                courseName: coursename,

            },
        });
    };

    return (




        <div className="container mt-1 p-3 mb-1" >


            <Row>
                <Col>
                    <h2 className=" text-center" style={{ color: '#123fae' }}
                    >
                        Certificate in English Communication and Soft Skills

                        {/* <a href='a'
                            style={{ float: "right", fontSize: 15, color: "#e74c3c" }}
                            className="d-block mx-auto"
                            onClick={(event) => {
                                event.preventDefault(); // Prevents the default behavior (page reload)
                                handleEnrollClick(); // Calls your handleEnrollClick function
                            }}
                        >
                            Register Now
                        </a> */}

                    </h2>




                </Col>
            </Row>


            {/* <h4>Course Details:</h4> */}



            {/* <h4>Course Details:</h4> */}
            < Row >
                <Col md={6} xs={12} className="mt-3 ">
                    <Card >
                        <CardHeader>
                            Course Details:
                        </CardHeader>




                        <ListGroup flush >

                            <ListGroupItem>
                                Language: English
                            </ListGroupItem>
                            <ListGroupItem>
                                Duration: 120 hours (3 months)
                            </ListGroupItem>
                            <ListGroupItem>
                                Learning Mode: Online
                            </ListGroupItem>
                            <ListGroupItem>
                                Certificate of Completion
                            </ListGroupItem>


                        </ListGroup>
                    </Card  ></Col>
                <Col md={6} xs={12} className="mt-3 ">
                    <Card style={{ minHeight: "100%", }}>
                        <CardHeader >
                            Eligibility:
                        </CardHeader>




                        <ListGroup flush className="px-2">

                            <ListGroupItem>
                                <li> Learner should preferably be a 12th std. Pass student.</li>

                            </ListGroupItem>

                        </ListGroup>
                    </Card></Col>
            </Row >
            <br />
            <hr />
            <h5 style={{ position: "relative" }}>
                <span >
                    &#x1F449;
                </span>
                Why English Communication and Soft Skills
            </h5>
            <p>
                This is flagship course with high quality eLearning content which emphasizes on English Communication and Soft Skills.
                This course offers detailed understanding and hands on experience of English Communication and Soft Skills.
            </p>
            <hr />

            <h5 style={{ position: "relative" }}>

                Need
            </h5>
            <ul>
                <li> We need special skill set for professional as well as personal life.</li>
                <li> Language Skills are needed to survive in the changing times. Development of Conversational Skills can help the learner in all aspects of life i.e. Professional, Social and Personal.</li>
                <li> Soft Skills are needed to survive in the changing times. Development of Soft Skills can help the learner in all aspects of life i.e. Professional, Social and Personal</li>
                <li> The course covers vital skills like Speaking, Listening, Reading, Writing and Understanding in English. Focuses on Vocabulary, Sentence structure, Pronunciation, Intonation (Voice, Pitch), Quality of Communication (Fluency, Emphasis, Pace, Clarity) , Non-verbal communication, Self-Management, Communication, Collaboration and Cooperation, Time Management, SMART Goal Setting, Decision Making, Interview skills and many more.</li>
            </ul>
            <hr />

            <h5 style={{ left: "0" }}>Certification</h5>
            <ul><li> English Communication and Soft Skills course is jointly certified by CDOE, GJUST and HKCL</li>
            </ul>
            
            <hr />
            <h5 style={{ left: "0" }}>Academic Approach</h5>
            <p>
                The academic approach of the courses focuses on the “work-centric” education i.e. begin with work (and not from a book!), derive knowledge from work and apply that knowledge to make the work more wholesome, useful and delightful. The ultimate objective is to empower the Learner to engage in socially useful and productive work. It aims at leading the learner to his/her rewarding career as an employee or entrepreneur as well as development of the community to which s/he belongs.
                Learning methodology:
            </p>


            <ul>
                <li>Step -1: Learners are given an overview of the course and its connection to life and work.</li>
                <li>Step -2: Learners are exposed to the specific tool(s) used in the course through the various real-life applications of the tool(s).</li>
                <li>Step -3: Learners are acquainted with the careers and the hierarchy of roles they can perform at workplaces after attaining increasing levels of mastery over the tool(s).</li>
                <li>Step -4: Learners are acquainted with the architecture of the tool or tool map so as to appreciate various parts of the tool, their functions, utility and inter-relations.</li>
                <li>Step -5: Learners are exposed to simple application development methodology by using the tool at the beginner’s level.</li>
                <li>Step -6: Learners perform the differential skills related to the use of the tool to improve the given ready-made industry-standard outputs.</li>
                <li>Step -7: Learners are engaged in appreciation of real-life case studies developed by the experts.</li>
                <li>Step -8: Learners are encouraged to proceed from appreciation to imitation of the experts.</li>
                <li>Step -9: After the imitation experience, they are required to improve the expert’s outputs so that they proceed from mere imitation to emulation.</li>
                <li>Step -10: Emulation is taken a level further from working with differential skills towards the visualization and creation of a complete output according to the requirements provided. (Long Assignments)</li>
                <li>Step -11: Understanding the requirements, communicating one’s own thoughts and presenting are important skills required in facing an interview for securing a work order/job. For instilling these skills, learners are presented with various subject-specific technical as well as HR-oriented questions and encouraged to answer them.</li>
                <li>Step -12: Finally, they develop the integral skills involving optimal methods and best practices to produce useful outputs right from scratch, publish them in their ePortfolio and thereby proceed from emulation to self-expression, from self-expression to self-confidence and from self-confidence to self-reliance and self-esteem!</li>
            </ul>
            <hr />

            <h5 style={{ left: "0" }}>Admission Guidelines</h5>
            <p>
              
                <ol>
                <li>
            <b>Online Registration: </b> Learner needs to visit <a href="https://www.gjuskillcourses.hkcl.in">www.gjuskillcourses.hkcl.in</a> and make an online payment for admission confirmation. Kindly refer online admission process guidelines for more details.
          </li>
                  
                </ol>
            </p>

            <hr />

            <h5>Syllabus</h5>
            <div className='p-4' >

                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="7">Functions and Grammar</AccordionHeader>
                        <AccordionBody accordionId="7">
                            <ul>
                                <li> Pronouns, Auxiliary and Action verbs</li>
                                <li>Punctuation</li>
                                <li> Conjugations</li>
                                <li> Participles</li>
                                <li>Prepositions</li>
                                <li> Questions</li>
                                <li> Articles</li>
                                <li> Verbs and Nouns</li>
                                <li>Present, Past and Future Tenses</li>
                                <li>Modal Verbs</li>
                                <li> Adjectives and Adverbs</li>
                                <li> Direct and Indirect Speech</li>
                                <li> Interrogative Sentences</li>
                                <li> Active and Passive Voice</li>
                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>

                {/* <h4>Basic IT Awareness</h4> */}

                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem>
                        <AccordionHeader targetId="8">Grammar Elements</AccordionHeader>
                        <AccordionBody accordionId="8">
                            <ul>
                                <li>Verbs - Auxiliary & Action with Prepositions & Nouns, Demonstrative Determiners like This, That, and Possessive Adjectives</li>
                                <li> How much/how many & very Prepositions & Pronouns</li>
                                <li> Auxiliary Verbs & Action Verbs, Possessive 's.</li>
                                <li>Demonstrative Determiners like Here/There, These/Those, Adverbs of frequency</li>
                                <li>Articles – with countable and uncountable nouns & Nouns & Adjectives,</li>
                                <li>Articles & Nouns (Countable- Plurals) AND Apostrophe</li>
                                <li>There-Their- They're & Conjunctions</li>
                                <li> WH-Interrogative with WORDS that are Both Nouns & Verbs + Possessive Pronouns</li>
                                <li> Wh-questions in the past & Conjunctions + Object Pronouns</li>
                                <li> Articles+ nouns (Uncountable) & Concrete & Abstract Nouns, Collective nouns</li>
                                <li> Nouns with Conjunctions & Homophones</li>
                                <li> Proper Nouns, Possessive 's & Modal Verbs (Can, could)</li>
                                <li> Nouns & Adjectives & Modal Verbs (May, Might)</li>
                                <li>Nouns+ Adjectives & Modal Verbs (Should, ought to)</li>
                                <li>Verbs & Adverbs & "I'd like" with Comparatives and Superlatives</li>
                                <li> Verbs & Adverbs & Modal Verbs (Shall, Used to, and "Going to")</li>
                                <li> Intensifiers - Basic , Interjections With Phrasal Verbs</li>
                                <li>Infinitive With Verb - Plus-ING – Like</li>
                                <li>Sentences - Positive to Negative & Question tags with Types of Sentences - Imperative & Exclamatory</li>
                                <li> Gerunds+ Participles with Phrases</li>
                                <li> Types of Sentences - Positive to Negative with Types of Sentences - Assertive & Interrogative</li>
                                <li> Either-or, Neither-nor , The Infinitive</li>
                                <li> Phrasal Verbs & Question tags</li>
                                <li> Verbs & Adverbs with Compound Words & Much-Many</li>
                                <li> Conditional (Zero & First)</li>
                                <li> Adverbial phrases of frequency, time and place with Subjunctive</li>
                                <li> Conditional (First & Second)</li>
                                <li> Prefix-Suffix with So-such</li>
                                <li>Direct - Indirect Speech with Synonyms-Antonyms</li>
                                <li> Active-passive voice (Intransitive Verbs) and Want-would like</li>
                            </ul>

                        </AccordionBody>
                    </AccordionItem>
                    <AccordionItem></AccordionItem>
                </Accordion>

                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem>
                        <AccordionHeader targetId="9">Tenses</AccordionHeader>
                        <AccordionBody accordionId="9">
                            <ul>
                                <li> Simple Present Tense</li>
                                <li> Present Continuous Tense</li>
                                <li> Present Perfect Tense</li>
                                <li> Simple Past Tense</li>
                                <li> Past Continuous Tense</li>
                                <li> Past Perfect Tense</li>
                                <li> Past Perfect Continuous Tense</li>
                                <li> Simple Future Tense</li>
                                <li> Future Continuous Tense</li>
                                <li> Future Perfect Tense</li>
                                <li> Future Perfect Continuous Tense</li>
                            </ul>

                        </AccordionBody>
                    </AccordionItem>
                    <AccordionItem>
                    </AccordionItem>
                </Accordion>

                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem>
                        <AccordionHeader targetId="10">Context Topics(Vocabulary)</AccordionHeader>
                        <AccordionBody accordionId="10">
                            <ul>
                                <li>Home and surrounding</li>
                                <li>Greetings-Routine, seasonal</li>
                                <li>Health-Healthy Habits</li>
                                <li>Farms-Farmers</li>
                                <li>Occupations</li>
                                <li>Traveling-transportations</li>
                                <li>Family-Relatives</li>
                                <li>Neighbours</li>
                                <li>Telling time</li>
                                <li>Friends</li>
                                <li>Describing people-places</li>
                                <li>Future plans-Savings</li>
                                <li>Accommodation</li>
                                <li>Public services: Bank, Post office, etc.</li>
                                <li>Education-Schooling</li>
                                <li>Competitions</li>
                                <li>Hobbies</li>
                                <li>Holidays-Picnics</li>
                                <li>Social media</li>
                                <li>Current Affairs</li>
                                <li>Remembering past</li>
                                <li>Safety</li>
                                <li>Natural disasters</li>
                                <li>Nationalities-Countries</li>
                                <li>Meetings -Presentations</li>
                                <li>Television-Films</li>
                                <li>Books-literature</li>
                                <li> Food</li>
                                <li> Requests</li>
                                <li> Dressing-clothing</li>
                                <li> Garden</li>
                                <li> Animals-Birds</li>
                                <li> Directions and addresses</li>
                                <li> Personal information</li>
                                <li>Games-Sports</li>
                                <li>Home town</li>
                                <li>Work and jobs</li>
                                <li>Look to the future</li>
                                <li>Giving gifts</li>
                                <li> City-Village life</li>
                                <li> Dreams</li>
                                <li> Shops- Marketplaces</li>
                                <li> Family traditions-Festivals</li>
                                <li> Office-Workplace</li>
                                <li> Soldiers-Army</li>
                                <li> Workplace ethics</li>
                                <li> Science-Technology</li>
                                <li> Computers & The Internet</li>
                                <li> Environment</li>
                                <li> Weather-Seasons</li>
                                <li> Numbers-Prices</li>
                            </ul>

                        </AccordionBody>
                    </AccordionItem>
                    <AccordionItem>
                    </AccordionItem>
                </Accordion>


                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem>
                        <AccordionHeader targetId="11">Soft Skills</AccordionHeader>
                        <AccordionBody accordionId="11">
                            <ul>
                                <li>Psychology of Success</li>s
                                <li>Self-Awareness and Self-Acceptance</li>s
                                <li>Self-Management</li>s
                                <li>Interpersonal Relationships</li>s
                                <li>Collaboration and Cooperation</li>s
                                <li>Time Management</li>s
                                <li>Smart Goal Setting</li>s
                                <li> Decision Making</li>s
                                <li>Problem Solving (Conflict Management)</li>s
                                <li>Emotional Intelligence</li>s
                                <li> Positive Health</li>s
                                <li>Ethics and Values</li>s
                                <li>Being Sensitive Towards Others, Society and Nature</li>s
                            </ul>

                        </AccordionBody>
                    </AccordionItem>
                    <AccordionItem>
                    </AccordionItem>
                </Accordion>
            </div>
            <hr />

            <h5>Objectives of the syllabus:</h5>
            <ul>
                <li> To make the learner proficient in English Language at a basic level as per the globally accepted standards.</li>
                <li>To help the learner imbibe communication skill necessary for job success with an exposure to verbal and written communication in various contextual situations in day-to-day life with continuous practice and drills through eLearning to ensure accuracy.</li>
                <li>To offer an exposure to communication skill in job / workplace situations involving thought provoking exercises with a continuous practice through eLearning so as to make him/her job ready and attain job success eventually.</li>
            </ul>
            {/* <h4>Job Readiness Skills</h4> */}
            <p>The syllabus has been standardized at par with CEFR (The Common European Framework of Reference for Languages) standards.</p>

            <p>The course covers the elements given below:</p>
            <ul>
                <li><b>Context Topics:</b> To ensure that effective communication is attained in relevant domain/subject area.</li>
                <li><b>Grammar Topics: </b>To make the learner well versed with the language correctly.</li>
            </ul>

            <p>The Syllabus ensures that the following skills are achieved:</p>
            <ul>
                <li>Listening </li>
                <li>Speaking</li>
                <li>Conversational Skills</li>
                <li>Reading</li>
                <li>Writing</li>
            </ul>
            <hr></hr>
            <div>
                <h5>Language Skills (L-S-C-R-W)</h5>
                <CardGroup>

                    <Card md={3}>
                        <CardHeader className="text-center">Listening (L)</CardHeader>
                        <CardBody className="d-block">
                            <ListGroupItem >
                                <ListGroupItemText>
                                    L 1 - Concentration
                                </ListGroupItemText>
                                <ListGroupItemText>
                                    L 2 - Interest in the topic
                                </ListGroupItemText>
                                <ListGroupItemText>
                                    L 3 - Sense making
                                </ListGroupItemText>
                                <ListGroupItemText>
                                    L 4 - Understanding
                                </ListGroupItemText>
                                <ListGroupItemText>
                                    L 5 - Deriving Meaning
                                </ListGroupItemText>
                                <ListGroupItemText>
                                    L 6 - Memorization and Recall
                                </ListGroupItemText>
                                <ListGroupItemText>
                                    L 7 - Reflection through Self Expression
                                </ListGroupItemText>
                            </ListGroupItem>
                        </CardBody>
                    </Card>
                    <Card md={3}>
                        <CardHeader className="text-center">Speaking (S)</CardHeader>
                        <CardBody className="d-block">
                            <ListGroupItem >
                                <ListGroupItemText>
                                    S 1 - Pronunciation
                                </ListGroupItemText>
                                <ListGroupItemText>
                                    S 2 - Fluency
                                </ListGroupItemText>
                                <ListGroupItemText>
                                    S 3 - Intonation
                                </ListGroupItemText>
                                <ListGroupItemText>
                                    S 4 - Clarity
                                </ListGroupItemText>
                                <ListGroupItemText>
                                    S 5 - Self Expression
                                </ListGroupItemText>
                            </ListGroupItem>
                        </CardBody>
                    </Card>
                    <Card md={3}>
                        <CardHeader className="text-center">Conversation ( C )</CardHeader>
                        <CardBody className="d-block">
                            <ListGroupItem >
                                <ListGroupItemText>
                                    C 1 - Active Listening
                                </ListGroupItemText>
                                <ListGroupItemText>
                                    C 2 - Responding
                                </ListGroupItemText>
                                <ListGroupItemText>
                                    C 3 - Self Expression
                                </ListGroupItemText>
                            </ListGroupItem>
                        </CardBody>
                    </Card>
                    <Card md={3}>
                        <CardHeader className="text-center">Reading ( R )</CardHeader>
                        <CardBody className="d-block">
                            <ListGroupItem >
                                <ListGroupItemText>
                                    R 1 - Concentration
                                </ListGroupItemText>
                                <ListGroupItemText>
                                    R 2- Deriving Meaning
                                </ListGroupItemText>
                                <ListGroupItemText>
                                    R 3 - Follow up reading
                                </ListGroupItemText>
                                <ListGroupItemText>
                                    R 4 - Loud reading
                                </ListGroupItemText>
                                <ListGroupItemText>
                                    R 5 - Silent reading
                                </ListGroupItemText>
                            </ListGroupItem>
                        </CardBody>
                    </Card>
                    <Card md={3}>
                        <CardHeader className="text-center">Writing (W)</CardHeader>
                        <CardBody className="d-block">
                            <ListGroupItem >
                                <ListGroupItemText>
                                    W 1- Understanding and clarity
                                </ListGroupItemText>
                                <ListGroupItemText>
                                    W 2 - Layout
                                </ListGroupItemText>
                                <ListGroupItemText>
                                    W 3 - Planning the content flow
                                </ListGroupItemText>
                                <ListGroupItemText>
                                    W 4 - Use of language appropriate to content
                                </ListGroupItemText>
                                <ListGroupItemText>
                                    W 5- Note making
                                </ListGroupItemText>
                                <ListGroupItemText>
                                    W 6 - Self Expression
                                </ListGroupItemText>
                            </ListGroupItem>
                        </CardBody>
                    </Card>
                </CardGroup>


            </div>
            <hr />



            <h5>Evaluation Pattern</h5>
            <Table bordered striped >
                <thead>
                    <tr>
                        <th>Section No.</th>
                        <th>Section Name</th>
                        <th>Total Marks</th>
                        <th>Minimum Passing Marks</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>1</td>
                        <td>Learning Progression</td>
                        <td>25</td>
                        <td>10</td>
                    </tr>
                    <tr>
                        <td>2</td>
                        <td>Internal Assessment</td>
                        <td>25</td>
                        <td>10</td>
                    </tr>
                    <tr>
                        <td>3</td>
                        <td>Final Online Examination</td>
                        <td>50</td>
                        <td>20</td>
                    </tr>
                    <tr>
                        <th colSpan="2" style={{ textAlign: "right" }}> Total</th>
                        <th>100</th>
                        <th>40</th>
                    </tr>
                  
                </tbody>
            </Table>
            <hr />

            <div>
                <h5>Certificate of Completion</h5>
                <p>
          The certificate will be provided to the learner who will satisfy the below criteria:
        </p>
        
          <li>
            Learners who have successfully completed above mentioned 3 Sections i.e. Section 1, Section 2, and Section 3.
          </li>
            </div>
            <div>
                <hr />
                <h5>Fee Structure</h5>
        <p>Fee applicable from 2024 Batch onwards as mentioned below:</p>
                <Table bordered>
                    <thead>
                        <tr>
                            <th>Mode</th>
                            <th>Total Fee (Rupees)</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Single Installment</td>
                            <td>4500/-</td>
                        </tr>
                    </tbody>
                </Table>
                <hr />
                <p>Total fee is including of Course fees, Examination fees, and Certification fees.</p>
            </div>
           
            <li>
        <span style={{ color: 'red' }}>
         Additionally, the One Time Registration Fee is Rs. 100/-. </span>
      </li>
           


        </div >

    );
}
export default CertificateInformation1;